import { Col, Row } from "reactstrap";
import HomeEstateCard from "../../../Dashboard/Project/TodoList/HomeEstateCard";

const HomeEstate = () => {
  return (
    <Col sm="6" xl="4">
      <Row>
        <HomeEstateCard />
      </Row>
    </Col>
  );
};

export default HomeEstate;
